export const journeyItems = [
  {
    slug: "kamfers-dam",
    name: "Kamfers Dam",
    category: "Nature Experience",
    location: "Kimberley",
    image: require("../assets/KamferDam.jpg"),
    description:
      "A haven for bird watchers and nature lovers, Kamfers Dam is home to thousands of flamingos with calm walking routes around the water.",
    content: [
      "Kamfers Dam is one of Kimberley's most memorable outdoor stops, especially for visitors who enjoy bird life, open views, and peaceful landscapes.",
      "The area is best experienced at an easy pace. Visitors can enjoy photography, gentle walking, and scenic viewing while keeping the environment undisturbed.",
    ],
    highlights: ["Flamingo viewing", "Photography", "Quiet nature stop"],
    bestFor: ["Bird lovers", "Nature walks", "Photography"],
    visitorNotes:
      "Go during softer morning or late afternoon light for the best viewing and photos.",
  },
  {
    slug: "mokala-national-park",
    name: "Mokala National Park",
    category: "National Park",
    location: "Near Kimberley",
    image: require("../assets/mokala-national-park-entrance-sign-01-500x300.jpg"),
    description:
      "Mokala National Park offers hiking trails through diverse landscapes, including savannahs, rocky hills, and riverine forests.",
    content: [
      "Mokala National Park is a strong choice for visitors who want a nature escape close to Kimberley. The park combines wildlife, open landscapes, and slower scenic routes.",
      "It works well as a day trip or a longer stop for travellers who want to add wildlife viewing and outdoor time to their Kimberley itinerary.",
    ],
    highlights: ["Wildlife viewing", "Scenic trails", "National park landscapes"],
    bestFor: ["Wildlife", "Day trips", "Outdoor travellers"],
    visitorNotes:
      "Check park operating details before travelling, especially for gate times and booking requirements.",
    officialWebsite: "https://www.sanparks.org/parks/mokala",
  },
  {
    slug: "the-big-hole-walks",
    name: "The Big Hole",
    category: "Historic Walk",
    location: "Kimberley",
    image: require("../assets/Fallback/Big Hole/bigHole04.jpg"),
    description:
      "The Big Hole area offers scenic walking paths with views of Kimberley's iconic landmark and surrounding historic landscape.",
    content: [
      "The Big Hole is mainly known for diamond mining history, but the surrounding area also gives visitors a walkable way to understand Kimberley's story.",
      "It is a useful stop for travellers who want history, photography, and an easy city-based activity without needing a long outdoor route.",
    ],
    highlights: ["Mining history", "Landmark views", "Easy walking"],
    bestFor: ["History", "First-time visitors", "City walks"],
    visitorNotes:
      "Pair it with the museum precinct to turn a short walk into a richer heritage visit.",
  },
  {
    slug: "magersfontein-battlefield",
    name: "Magersfontein Battlefield",
    category: "Heritage Trail",
    location: "Kimberley area",
    image: require("../assets/Fallback/Magersfontein Battlefield/magersfonteinBattlefield05.jpg"),
    description:
      "This historical site offers walking trails through battlefield terrain with insights into the Anglo-Boer War.",
    content: [
      "Magersfontein Battlefield gives visitors a slower, more reflective outdoor heritage experience. It connects landscape, memory, and military history.",
      "The site is especially valuable for travellers who want more than a photo stop and prefer walking through places where Kimberley's regional history becomes tangible.",
    ],
    highlights: ["Battlefield history", "Walking trails", "Quiet heritage setting"],
    bestFor: ["Heritage", "Walking", "History learners"],
    visitorNotes:
      "Bring water and allow enough time to read the historical context as you move through the site.",
  },
  {
    slug: "rooipoort-nature-reserve",
    name: "Rooipoort Nature Reserve",
    category: "Nature Reserve",
    location: "Kimberley area",
    image: require("../assets/PL-RooiPoort.jpg"),
    description:
      "Rooipoort offers rugged hiking trails through pristine wilderness, with opportunities to spot wildlife and bird species.",
    content: [
      "Rooipoort Nature Reserve is a good fit for visitors looking for a more rugged outdoor experience around Kimberley.",
      "The reserve brings together open landscapes, trail-style exploration, and the possibility of spotting wildlife, making it a stronger adventure option than a simple viewpoint.",
    ],
    highlights: ["Rugged trails", "Wildlife", "Birding"],
    bestFor: ["Adventure", "Nature", "Trail walks"],
    visitorNotes:
      "Wear comfortable shoes and confirm access details before heading out.",
  },
  {
    slug: "augrabies-falls-national-park",
    name: "Augrabies Falls National Park",
    category: "National Park",
    location: "Northern Cape",
    image: require("../assets/images (6).jfif"),
    description:
      "Augrabies Falls National Park is known for its waterfall, rugged landscapes, and dramatic Orange River views.",
    content: [
      "Augrabies Falls National Park is a bigger excursion from Kimberley, but it rewards visitors with dramatic natural scenery and strong landscape photography opportunities.",
      "It is best suited to travellers building a wider Northern Cape route rather than visitors with only a short time in the city.",
    ],
    highlights: ["Waterfall views", "River gorge", "Northern Cape landscapes"],
    bestFor: ["Road trips", "Photography", "Nature"],
    visitorNotes:
      "Plan travel time carefully, as this is better suited to a longer Northern Cape itinerary.",
    officialWebsite: "https://www.sanparks.org/parks/augrabies",
  },
  {
    slug: "richtersveld-national-park",
    name: "Richtersveld National Park",
    category: "National Park",
    location: "Northern Cape",
    image: require("../assets/richtersveld_national_park_landscape.jpg"),
    description:
      "Richtersveld National Park is known for dramatic desert landscapes, unique flora, and the Orange River.",
    content: [
      "Richtersveld National Park is a remote, dramatic landscape experience for travellers who want the wilder side of the Northern Cape.",
      "It is less of a quick Kimberley stop and more of a destination for adventurous planners building a serious nature route.",
    ],
    highlights: ["Desert scenery", "Unique flora", "Remote adventure"],
    bestFor: ["Adventure", "Long trips", "Nature lovers"],
    visitorNotes:
      "Research access, vehicle needs, and accommodation before committing to this route.",
    officialWebsite: "https://www.sanparks.org/parks/richtersveld",
  },
  {
    slug: "william-humphreys-gallery-gardens",
    name: "William Humphreys Art Gallery Gardens",
    category: "Nature Experience",
    location: "Kimberley",
    image: require("../assets/william.jpg"),
    description:
      "The gardens surrounding the gallery offer a calmer cultural stop with greenery, sculptures, and nearby art experiences.",
    content: [
      "This stop is useful for visitors who want a softer, slower break between larger attractions.",
      "The gardens can work as a short nature pause while still keeping visitors close to Kimberley's cultural and historical core.",
    ],
    highlights: ["Garden setting", "Art nearby", "Short relaxed stop"],
    bestFor: ["Culture", "Easy visits", "Calm breaks"],
    visitorNotes:
      "Combine it with the gallery visit for a balanced indoor and outdoor experience.",
  },
];

export const findJourneyItem = (slug) =>
  journeyItems.find((item) => item.slug === slug);
